import { create } from "zustand";
/** Session-local suppression keeps a failed opt-out from silently resuming collection. */
const useStops = create<{ actors: ReadonlySet<string> }>(() => ({
  actors: new Set(),
}));
export function stopAnalyticsForActor(actorKey: string) {
  useStops.setState((state) => ({
    actors: new Set(state.actors).add(actorKey),
  }));
}
export function analyticsStoppedForActor(actorKey: string) {
  return useStops.getState().actors.has(actorKey);
}
export function useAnalyticsStopped(actorKey: string) {
  return useStops((state) => state.actors.has(actorKey));
}
export function acceptAnalyticsConsent(actorKey: string, consented: boolean) {
  if (!consented) {
    stopAnalyticsForActor(actorKey);
    return;
  }
  useStops.setState((state) => {
    const actors = new Set(state.actors);
    actors.delete(actorKey);
    return { actors };
  });
}
